import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'app-extensions',
});

export const appExtensionRouteRef = createRouteRef({
  id: 'app-extensions/extension',
  params: ['extensionId'],
});
